export class TwoFactor {
    constructor() {
        this.enabled = (document.querySelector('.dropdown-menu[role=profile]').dataset.twofaGlobalEnabled == 1 ? true : false);

        if (this.enabled) {
            document.querySelector('#enable-2fa').onclick = event => {
                this.showModal();
            };

            document.querySelectorAll('*[data-dismiss=modal]').forEach(button => {
                button.onclick = event => {
                   this.closeModal();
                };
            });
        }
    }

    showModal() {
        $('._2fa-modal').modal('show');
    }

    closeModal() {
        $('._2fa-modal').modal('hide');
    }
}
